import { render, staticRenderFns } from "./ObjectImages.vue?vue&type=template&id=b6b0b216&"
import script from "./ObjectImages.vue?vue&type=script&lang=js&"
export * from "./ObjectImages.vue?vue&type=script&lang=js&"
import style0 from "./ObjectImages.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports